import React, { useState, useReducer, useRef, useEffect } from 'react'
import {
  TextField,
  Checkbox,
  FormControlLabel,
  Select,
  MenuItem
} from '@material-ui/core'
import {
  DatePicker,
  MuiPickersUtilsProvider
} from '@material-ui/pickers'
import DateFnsUtils from '@date-io/date-fns'
import axios from 'axios'
import { useDispatch, useSelector } from 'react-redux'
import useStyles from './styles'
import { formReducer, getFieldError } from 'helpers/forms'
import { getByIdFromArray } from 'helpers/dataHelpers'
import { checkErrorStatus, setSnackbar } from 'utils/common/actions'
import Modal from 'components/Modal'
import Config from 'config'

const initFormsState = {
  errors: {}
}

const iterations = [
  {value: 'YEARLY', name: 'Yearly'},
  {value: 'MONTHLY', name: 'Monthly'},
  {value: 'WEEKLY', name: 'Weekly'}
]


const AddActionModal = (props) => {
  const {
    actionId,
    setShowDialog,
    showDialog,
    getValue,
    actionData
  } = props
  const { apiUrl } = Config.network
  const dispatch = useDispatch()
  const [formErrors, dispatchFormErrors] = useReducer(formReducer, initFormsState)
  const [isLoading, setIsLoading] = useState(false)
  const [selectedDate, setSelectedDate] = useState(new Date())
  const [isRecurring, setIsRecurring] = useState(actionData ? actionData.recurring : false)
  const [iteration, setIteration] = useState(iterations[0].value)

  const actions = useSelector(state => state.actions.actions)

  useEffect(() => {
    dispatchFormErrors({ type: 'reset' })
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  const getActionData = () => {
    let adviceDict = null
    if (actionId) {
      adviceDict = getByIdFromArray(actions, actionId)
    }
    if (!adviceDict && actionData && actionData.text) {
      adviceDict = actionData
    }
    return adviceDict
  }

  const activeAction = getActionData()

  useEffect(() => {
    if (activeAction && activeAction.deadline) {
      setSelectedDate(new Date(activeAction.deadline))
    }
    if (activeAction && activeAction.recurring && activeAction.iteration) {
      setIteration(activeAction.iteration)
    }
  }, [activeAction]) // eslint-disable-line react-hooks/exhaustive-deps
  
  const formRef = useRef()

  const localClasses = useStyles()


  const addActionSubmit = (event) => {
    event.preventDefault()
    event.stopPropagation()
    dispatchFormErrors({ type: 'reset' })
    setIsLoading(true)
    const url = `${apiUrl}actions/`
    const text = event.target.elements.text.value
    const responsible_party = event.target.elements.responsible_party.value
    const deadline = `${selectedDate.getFullYear()}-${selectedDate.getMonth() + 1 < 10 ? '0' + (selectedDate.getMonth() + 1) : selectedDate.getMonth() + 1}-${selectedDate.getDate() < 10 ? '0' + selectedDate.getDate() : selectedDate.getDate()}`
    const requestData = {
      text: text,
      responsible_party: responsible_party,
      deadline: deadline,
      recurring: isRecurring
    }
    if (isRecurring) {
      requestData['iteration'] = iteration
    }
    axios.post(url, requestData).then((body) => {
      const { data } = body
      setIsLoading(false)
      if (getValue) {
        getValue('create', data)
      }
      dispatch(setSnackbar('Action created'))
      setShowDialog(false)
    }).catch(err => {
      if (err.response) {
        dispatch(checkErrorStatus(err.response.status))
        setIsLoading(false)
        if (err.response.status === 400) {
          dispatchFormErrors({
            type: 'error',
            payload: err.response.data
          })
        } else {
          dispatchFormErrors({
            type: 'error',
            payload: {
              nonField: [err.response.data.detail]
            }
          })
        }
      } else {
        dispatch(setSnackbar('Connection error', 'error'))
      }
    })
  }

  const editActionSubmit = (event) => {
    event.preventDefault()
    event.stopPropagation()
    dispatchFormErrors({ type: 'reset' })
    setIsLoading(true)
    const url = `${apiUrl}tasks/${actionId}/`
    const text = event.target.elements.text.value
    const responsible_party = event.target.elements.responsible_party.value
    const deadline = `${selectedDate.getFullYear()}-${selectedDate.getMonth() + 1 < 10 ? '0' + (selectedDate.getMonth() + 1) : selectedDate.getMonth() + 1}-${selectedDate.getDate() < 10 ? '0' + selectedDate.getDate() : selectedDate.getDate()}`
    const requestData = {
      text: text,
      responsible_party: responsible_party,
      deadline: deadline,
      recurring: isRecurring
    }
    if (isRecurring) {
      requestData['iteration'] = iteration
    }
    axios.put(url, requestData).then((body) => {
      const { data } = body

      if (getValue) {
        getValue('edit', data)
      }
      dispatch(setSnackbar('Action updated'))
      setIsLoading(false)
      setShowDialog(false)
    }).catch(err => {
      if (err.response) {
        dispatch(checkErrorStatus(err.response.status))
        setIsLoading(false)
        if (err.response.status === 400) {
          dispatchFormErrors({
            type: 'error',
            payload: err.response.data
          })
        } else {
          dispatchFormErrors({
            type: 'error',
            payload: {
              nonField: [err.response.data.detail]
            }
          })
        }
      } else {
        dispatch(setSnackbar('Connection error', 'error'))
      }
    })
  }

  return (
    <Modal
      open={showDialog}
      onClose={() => setShowDialog(false)}
      header={actionId ? 'Edit Action' : 'Add Action'}
      isLoading={isLoading}
      action={() => formRef.current.dispatchEvent(new Event('submit'))}
      actionText={actionId ? 'Save' : 'Create Action'}
      secondaryAction={() => setShowDialog(false)}
      disableEnforceFocus
    >
      <form onSubmit={actionId ? editActionSubmit : addActionSubmit} ref={formRef}>
        { getFieldError(formErrors, 'nonField') ?
        <p className='error-message'>{getFieldError(formErrors, 'nonField')}</p> : null }

          <TextField
            required
            error={!!getFieldError(formErrors, 'text')}
            helperText={getFieldError(formErrors, 'text')}
            label='Desctiption'
            type='text'
            name='text'
            fullWidth
            variant='outlined'
            multiline
            minRows={6}
            maxRows={6}
            defaultValue={activeAction ? activeAction.text : null}
            color='secondary'
            className={localClasses.textField}
            InputLabelProps={{
              shrink: true,
              required: true
            }}
          />

          <TextField
            required
            error={!!getFieldError(formErrors, 'responsible_party')}
            helperText={getFieldError(formErrors, 'responsible_party')}
            label='Responsible party'
            type='text'
            name='responsible_party'
            fullWidth
            variant='outlined'
            defaultValue={activeAction ? activeAction.responsible_party : null}
            color='secondary'
            className={localClasses.textField}
            InputLabelProps={{
              shrink: true,
              required: true
            }}
          />

          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <DatePicker
              autoOk
              className={localClasses.dateTimePicker}
              disableToolbar
              variant='inline'
              format='dd-MM-yyyy'
              margin='normal'
              id='date-picker-inline'
              label='Deadline'
              value={selectedDate}
              TextFieldComponent={(props) =>
                <TextField
                  {...props}
                  InputLabelProps={{
                    shrink: true,
                    required: true
                  }}
                  color='secondary'
                  required
                  fullWidth
                  helperText={null}
                  variant='outlined'
                  inputProps={{
                    ...props.inputProps,
                    readOnly: true
                  }}
                />
              }
              onChange={(date) => {
                setSelectedDate(date)
              }}
            />
          </MuiPickersUtilsProvider>


          <FormControlLabel
            control={
              <Checkbox
                checked={isRecurring}
                onChange={(event) => setIsRecurring(event.currentTarget.checked)}
              />
            }
            label='Recurring?'
            className={localClasses.checkbox}
          />

          <Select
            disabled={!isRecurring}
            labelId='iterationLabel'
            id='iterationSelect'
            value={iteration}
            variant='outlined'
            onChange={(event) => setIteration(event.target.value)}
            className={localClasses.select}
            color='secondary'
          >
            {
              iterations.map((iteration, index) => <MenuItem key={`iteration-${index}`} value={iteration.value}>{iteration.name}</MenuItem>)
            }
          </Select>

      </form>
    </Modal>
  )
}

export default AddActionModal
